<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<mat-card class="content-card" style="padding-top: 15px; padding-bottom: 0; margin-top: 0; border-top-left-radius: 0; border-top-right-radius: 0;">

  <div>
    <div fxLayout="column" fxFlex="50">
      <div fxLayout="row wrap" fxLayoutGap="30px" fxLayoutAlign="flex-start center">

        <mat-form-field class="brand-filter-field" *ngIf="!currentUserIsPartner()">
          <mat-select [formControl]="companySelect" placeholder="Brand filters" (selectionChange)="onCompanyChange()" [(ngModel)]="companiesFilter" multiple>
            <mat-option *ngFor="let company of companies" [value]="company.id">{{company.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>


        <!-- #region star-end data, date filters, search -->



        <!-- #endregion star-end data, date filters, search -->

        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field style="width: 50px;" class="search-field">
            <input #startField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Start"
                   [(ngModel)]="start">
          </mat-form-field>
          <mat-form-field style="width: 50px;" class="search-field">
            <input #countField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Count"
                   [(ngModel)]="count">
          </mat-form-field>
          <button #searchButton mat-icon-button (click)="onSearch(false)">
            <mat-icon>search</mat-icon>
          </button>
          <button mat-icon-button (click)="clearFilter()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>


        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field style="width: 400px;" class="search-field">
            <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search"
                   [(ngModel)]="str">
          </mat-form-field>
          <button #searchButton mat-icon-button (click)="onSearch(false)">
            <mat-icon>search</mat-icon>
          </button>
          <button mat-icon-button (click)="clearFilter()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      </div>
    </div>




    <div fxLayout="column" fxFlex="50">

    </div>

  </div>
</mat-card>

<div>
  <mat-card class="content-card">
    <mat-card-header>
      <mat-card-title>
        <h5>Last Card Activities</h5>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <ng-container *ngIf="list">
        <table>
          <thead>
          <tr>
            <th>Token</th>
            <th>Customer</th>
            <th>Product</th>
            <th>Amount</th>
            <th>Date</th>
            <th>Description</th>
            <th>Type</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let card of list">
            <td class="mat-column-cardToken">{{ card.cardToken }}</td>
            <td>
              <a style="text-decoration: none;" [routerLink]="'../../../customers-overview/' + card.customerId">
                {{card.customerFirstname}} {{card.customerLastname}}
              </a>
            </td>
            <td>{{card.productName}}</td>
            <td class="mat-column-amount">
              <div style="text-align: right">{{card.amount | number: "1.2-2"}}</div>
            </td>
            <td class="mat-column-activityDate">{{card.activityDate | date: "dd.MM.yyyy HH:mm"}}</td>
            <td>
              <div style="display: block; white-space: pre-wrap;">{{ card.description }}</div>
              <div style="display: block;" *ngIf="card.notes">{{ card.notes }}</div>
              <div *ngIf="card.gpsPosData" style="font-size: .9em; font-family: monospace; margin-bottom: 2px; display: block; margin-top: 3px;" [class]="'statement-posdata-'" data-pos-data="{{ card.posData }}">
                <span class="posDataBadge posDataGood" *ngIf="(card.gpsPosData?.scaTestBiometric ?? SCATestResult.NotPerformed) == SCATestResult.Passed">3DS ok</span>
                <span class="posDataBadge posDataBad" *ngIf="(card.gpsPosData?.scaTestBiometric ?? SCATestResult.NotPerformed) == SCATestResult.Failed">3DS fail</span>
                <!--<span class="posDataBadge" *ngIf="(element.gpsPosData?.scaTestBiometric ?? SCATestResult.NotPerformed) == SCATestResult.NotPerformed">No 3DS</span>-->
                <span [matTooltip]="'Card present'" class="posDataBadge posDataGood" *ngIf="(card.gpsPosData?.cardPresent ?? CardPresent.Unknown) == CardPresent.Present">💳✅</span>
                <span [matTooltip]="'Card not present'" class="posDataBadge posDataWarn" *ngIf="(card.gpsPosData?.cardPresent ?? CardPresent.Unknown) == CardPresent.NotPresent">💳❌</span>
                <span [matTooltip]="'Cardholder present'" class="posDataBadge posDataGood" *ngIf="(card.gpsPosData?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.Present">🙋✅</span>
                <span [matTooltip]="'Cardholder not present'" class="posDataBadge posDataWarn" *ngIf="(card.gpsPosData?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.NotPresentUnspecified || (card.gpsPosData?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.ECommerce">🙋❌</span>
                <span class="posDataBadge posDataInfo" *ngIf="(card.gpsPosData?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.RecurringTransaction">Recurring Txn</span>
                <span class="posDataBadge posDataBad" *ngIf="(card.gpsPosData?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.TelephoneOrder">Tel. order</span>
                <span class="posDataBadge posDataBad" *ngIf="(card.gpsPosData?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.MailOrder">Mail order</span>
                <span class="posDataBadge posDataInfo" *ngIf="(card.gpsPosData?.cardDataInputMethod ?? false) == CardDataInputMethod.ECommerce || (card.gpsPosData?.cardholderPresent ?? CardholderPresent.Unknown) == CardholderPresent.ECommerce">ECommerce</span>
                <span class="posDataBadge posDataInfo" *ngIf="(card.gpsPosData?.cardDataInputMethod ?? false) == CardDataInputMethod.EMVContactless">EMV Contactless</span>
                <span class="posDataBadge posDataGood" *ngIf="(card.gpsPosData?.cardDataInputMethod ?? false) == CardDataInputMethod.ChipDip">ChipDip</span>
                <span class="posDataBadge posDataWarn" *ngIf="(card.gpsPosData?.cardDataInputMethod ?? false) == CardDataInputMethod.AccountDataOnFile">Acct.Data on File</span>
                <span class="posDataBadge posDataBad" *ngIf="(card.gpsPosData?.cardDataInputMethod ?? false) == CardDataInputMethod.MagneticStripeRead">Mag. Stripe Read</span>
                <span class="posDataBadge posDataBad" *ngIf="(card.gpsPosData?.cardDataInputMethod ?? false) == CardDataInputMethod.ContactlessMagStripe">Contactless Mag. Stripe</span>
                <span class="posDataBadge posDataGood" *ngIf="isPinAuth(card.gpsPosData)">🔐 PIN</span>
                <span class="posDataBadge posDataGood" *ngIf="isSecure3DsAuth(card.gpsPosData)">🔐 3DS</span>
                <span class="posDataBadge posDataGood" *ngIf="isBiometricsAuth(card.gpsPosData)">🔐 Biometrics</span>
              </div>
            </td>
            <td class="mat-column-activityType">
              <ng-container *ngIf="card.activityType === cardActivityType.Load">💰 Load</ng-container>
              <ng-container *ngIf="card.activityType === cardActivityType.Presentment">✅ Payment</ng-container>
              <ng-container *ngIf="card.activityType === cardActivityType.CashWithdrawal">🏧 Cash withdraw</ng-container>
              <ng-container *ngIf="card.activityType === cardActivityType.Presentment && card.procCode == '390000'">💳 ASI Check</ng-container>
              <ng-container *ngIf="card.activityType === cardActivityType.Presentment && card.procCode != '390000'">⌛ ️Auth</ng-container>
              <ng-container *ngIf="card.activityType === cardActivityType.Reversal">↩️ Reversal</ng-container>
              <ng-container *ngIf="card.activityType === cardActivityType.LoadFromPrimary">Load from primary</ng-container>
              <ng-container *ngIf="card.activityType === cardActivityType.BalanceAdjustment">Balance Adjustment</ng-container>
              <ng-container *ngIf="card.activityType === 99">◼️ Other</ng-container>
            </td>
            <td>{{card.txnStatCode}}</td>
          </tr>
          </tbody>
        </table>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>

